import { Controller } from "@hotwired/stimulus"

// Keeps a scrollable container pinned to the bottom: on connect (initial load)
// and whenever its contents change (e.g. a Turbo Stream appends a new message).
// Used by the agent Help conversation.
export default class extends Controller {
  connect() {
    this.scrollToBottom()
    this.observer = new MutationObserver(() => this.scrollToBottom())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
